/**
 * <newsletter-slidein> (sections/newsletter-slidein.liquid): the one optional newsletter prompt.
 * track() counts visits (one per browser session) and product views in localStorage and offers
 * the slide-in once only: after two product views, and never during the first visit.
 */
import { defineElement } from '@wispaire/global';

const VIEWS = 'wispaire:product-views';
const VISITS = 'wispaire:visits';
const SEEN = 'wispaire:slidein-seen';
const SESSION = 'wispaire:visit';

const count = (store, key) => Number(store.getItem(key)) || 0;

/** Records this page view and says whether to offer the slide-in now (marking it seen if so). */
export function track(local, session, { productView }) {
  if (!session.getItem(SESSION)) {
    session.setItem(SESSION, '1');
    local.setItem(VISITS, count(local, VISITS) + 1);
  }
  if (productView) local.setItem(VIEWS, count(local, VIEWS) + 1);
  const offer = count(local, VIEWS) >= 2 && count(local, VISITS) >= 2 && !local.getItem(SEEN);
  if (offer) local.setItem(SEEN, '1');
  return offer;
}

const Base = globalThis.HTMLElement ?? class {};

class NewsletterSlidein extends Base {
  connectedCallback() {
    let offer = false;
    try {
      offer = track(localStorage, sessionStorage, { productView: this.hasAttribute('data-product-view') });
    } catch {
      // Storage blocked: never offer.
    }
    // Its own form just posted: show the result. The theme editor always shows it.
    const posted = this.querySelector('.newsletter__success, .newsletter__error');
    if (posted || globalThis.Shopify?.designMode) this.hidden = false;
    else if (offer) setTimeout(() => (this.hidden = false), 2500);

    this.querySelector('[data-slidein-close]').addEventListener('click', () => (this.hidden = true));
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.hidden = true;
    });
  }
}

defineElement('newsletter-slidein', NewsletterSlidein);
